import React, { useEffect, useState } from 'react';
import { Calendar } from 'react-date-range';
import classes from './DatePicker.module.css';
import ModalComponent from '../../ModalComponent/ModalComponent';
import moment from 'moment';
import { UilSchedule } from '@iconscout/react-unicons';
import { useField } from 'formik';

const DatePickerWithFormik = ({ date, setDate, disabled, showArrow = false, format = null, ...props }) => {
    const [showCalender, setShowCalender] = useState(false);
    const [currentDate, setCurrentDate] = useState(null);

    const [values, setValues] = useState(null);
    const [, meta, helpers] = useField(props);

    useEffect(() => {
        if (date) {
            date = new Date(date);
            setCurrentDate(date);
            handleSelect(date);
        }
    }, [JSON.stringify(date)]);

    const handleSelect = (date) => {
        const currentDate = new Date();
        date.setHours(currentDate.getHours());
        date.setMinutes(currentDate.getMinutes());
        date.setSeconds(currentDate.getSeconds());
        setDate && setDate(date);
        setCurrentDate(date);
        setShowCalender(false);
        setValues(date);
        helpers.setValue && helpers.setValue(date);
    };
    const handleBackClick = () => {
        const previousDay = new Date(date);
        previousDay.setDate(previousDay.getDate() - 1);
        setDate && setDate(previousDay);
        setCurrentDate(previousDay);
        setValues(previousDay);
        helpers.setValue && helpers.setValue(previousDay);
    };

    const handleNextClick = () => {
        const nextDay = new Date(date);
        nextDay.setDate(nextDay.getDate() + 1);
        setDate && setDate(nextDay);
        setCurrentDate(nextDay);
        setValues(nextDay);
        helpers.setValue && helpers.setValue(nextDay);
    };

    const style = {
        opacity: disabled && '0.5',
        height: showArrow && '2Vh',
    };

    return (
        <div>
            <div className={classes.DatePickerContainer} style={disabled ? { opacity: '0.5' } : {}}>
                {showArrow && (
                    <div className={classes.ArrowButton} onClick={() => !disabled && handleBackClick()}>
                        {'<'}
                    </div>
                )}
                <div className={classes.DateContainer} onClick={() => !disabled && setShowCalender(!showCalender)} style={showArrow ? { height: '2vw' } : {}}>
                    <div className={classes.Date}>{currentDate && format ? moment(currentDate).format(format) : currentDate ? moment(currentDate).format('MMM DD YYYY') : ''}</div>
                    <div className={classes.CalendarIcon}>
                        <UilSchedule style={{ color: 'var(--color-primary)' }} size={'1.3vw'} />
                    </div>
                </div>
                {showArrow && (
                    <div className={classes.ArrowButton} onClick={() => !disabled && handleNextClick()}>
                        {'>'}
                    </div>
                )}
            </div>

            {showCalender && (
                <ModalComponent isOpen={showCalender} setOpen={setShowCalender}>
                    <Calendar className={classes.CalendarPopUp} date={date} onChange={handleSelect} autoFocus={false} color="var(--color-primary)" fixedHeight={true} />
                </ModalComponent>
            )}
            {meta.touched && meta.error ? <div className="error-msg">{meta.error}</div> : null}
        </div>
    );
};

export default DatePickerWithFormik;
